import React from "react";
import {
  FaHome,
  FaDollarSign,
  FaCalendarCheck,
  FaUser,
  FaBox,
  FaTag,
  FaEdit,
  FaBullhorn,
  FaFileAlt,
  FaUserCog,
  FaQuestionCircle,
} from "~shared/icons/fa";

function RecipeIcon() {
  return (
    <svg width={16} viewBox="0 0 22.666 26.735">
      <g data-name="Group 340">
        <g data-name="Group 339">
          <path
            data-name="Path 176"
            d="M.8 0a.8.8 0 00-.8.8v25.135a.8.8 0 00.8.8h1.826V0z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 342">
        <g data-name="Group 341">
          <path
            data-name="Rectangle 1208"
            fill="#fff"
            d="M10.093 14.903h5.32v1.752h-5.32z"
          />
        </g>
      </g>
      <g data-name="Group 344">
        <g data-name="Group 343">
          <path
            data-name="Path 177"
            d="M18.868 0H4.196v26.735h14.673a3.8 3.8 0 003.8-3.8V3.8A3.8 3.8 0 0018.868 0zm-1.887 14.766v2.673a.784.784 0 01-.784.784H9.308a.784.784 0 01-.784-.784v-2.656a2.617 2.617 0 011.484-5.019 3.077 3.077 0 015.86.519 2.321 2.321 0 011.113 4.483z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 346">
        <g data-name="Group 345">
          <path
            data-name="Path 178"
            d="M16.197 11.829a.75.75 0 00-.512.2.782.782 0 01-1.317-.57v-.625a1.509 1.509 0 00-3.015.089v.021a.793.793 0 01-1.378.537 1.048 1.048 0 10-.664 1.859H16.2a.753.753 0 000-1.506z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default [
  {
    title: "Dashboard",
    icon: <FaHome />,
    // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/dash/",
    url: `/retailer/dash/`,
    isBookitSpecific: false,
    retailerSpecific: true,
    hasInnerRoutes: false,
  },
  {
    title: "Manage Orders",
    icon: <FaDollarSign />,
    // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/orders/instore-pickup/",
    url: `/retailer/orders/instore-pickup/`,
    isBookitSpecific: false,
    retailerSpecific: true,
    hasInnerRoutes: false,
  },
  {
    title: "Booking",
    icon: <FaCalendarCheck />,
    hasInnerRoutes: true,
    isBookitSpecific: true,
    routes: [
      {
        title: "Schedule",
        icon: null,
        hasInnerRoutes: false,
        url: "/retailer/booking/schedule",
        isBookitSpecific: true,
      },
      
     
      // {
      
      //   title: "New Slot",
      //   icon: null,
      //   hasInnerRoutes: false,
      //   url: "/retailer/booking/availabilityPage",
      //   isBookitSpecific: true,
      // },
      {
        title: "Appointments",
        icon: null,
        hasInnerRoutes: false,
        url: "/retailer/booking/appointments",
        isBookitSpecific: true,
      },
      {
        title: "Configuration",
        icon: null,
        hasInnerRoutes: false,
        url: "/retailer/booking/configuration",
        isBookitSpecific: true,
      },
    ],
  },
  {
    title: "Customers",
    icon: <FaUser />,
    url: `/retailer/customers/`,
    isBookitSpecific: false,
    "retailerSpecific": true,
    // "url": "/retailer/customers/16/pet-list",
    // "isBookitSpecific": true,
    hasInnerRoutes: false,
  },
  {
    title: "Manage Catalog",
    icon: <FaBox />,
    hasInnerRoutes: true,
    isBookitSpecific: false,
    routes: [
      {
        title: "My Products",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/store-products/",
        url: `/retailer/store-products/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
      {
        title: "Product Universe",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/products/search/",
        url: `/retailer/products/search/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
    ],
  },
  {
    title: "Promos",
    icon: <FaTag />,
    hasInnerRoutes: true,
    isBookitSpecific: false,
    routes: [
      {
        title: "Promo Codes",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/promos/",
        url: `/retailer/promos/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
      {
        title: "Price Slash",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/price-slash/",
        url: `/retailer/price-slash/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
    ],
  },
  {
    title: "Content",
    icon: <FaEdit />,
    // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/content/",
    url: `/retailer/content/`,
    retailerSpecific: true,
    isBookitSpecific: false,
    hasInnerRoutes: false,
  },
  {
    title: "Marketing",
    icon: <FaBullhorn />,
    hasInnerRoutes: true,
    isBookitSpecific: false,
    routes: [
      {
        title: "ShareIt!",
        icon: null,
        hasInnerRoutes: false,
        url: "https://social.etailpet.com/#auth?error_type=FailedAuth&error_message=Username%20or%20password%20is%20invalid.",
        retailerSpecific: false,
        isBookitSpecific: false,
      },
      // {
      //   title: "ListIt!",
      //   icon: null,
      //   hasInnerRoutes: false,
      //   url: `/retailer/listings/`,
      //   retailerSpecific: true,
      //   isBookitSpecific: false,
      // },
      // {
      //   title: "ReviewIt!",
      //   icon: null,
      //   hasInnerRoutes: false,
      //   url: "https://social.etailpet.com/#auth?error_type=FailedAuth&error_message=Username%20or%20password%20is%20invalid.",
      //   retailerSpecific: false,
      //   isBookitSpecific: false,
      // },
      {
        title: "Product Reviews",
        icon: null,
        hasInnerRoutes: false,
        url: `/retailer/product-reviews/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
    ],
  },
  {
    title: "Reports",
    icon: <FaFileAlt />,
    // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/reports/",
    url: `/retailer/reports/`,
    retailerSpecific: true,
    isBookitSpecific: false,
    hasInnerRoutes: false,
  },
  {
    title: "Admins and Crews",
    icon: <FaUserCog />,
    hasInnerRoutes: true,
    isBookitSpecific: false,
    routes: [
      {
        title: "Admin Users",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/admins/",
        url: `/retailer/admins/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
      {
        title: "Crews",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/crews/",
        url: `/retailer/crews/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
      {
        title: "Roles",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/admins/roles/",
        url: `/retailer/admins/roles/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
    ],
  },
  {
    title: "Recipes",
    icon: <RecipeIcon />,
    hasInnerRoutes: true,
    isBookitSpecific: false,
    routes: [
      {
        title: "Recipe Admin",
        icon: null,
        hasInnerRoutes: false,
        // "url": "https://etailadmin:pwd%40123@awesomepets.dev.etailpet.com/retailer/recipe-admin/",
        url: `/retailer/recipe-admin/`,
        retailerSpecific: true,
        isBookitSpecific: false,
      },
    ],
  },
  {
    title: "Help",
    icon: <FaQuestionCircle />,
    url: "https://etailpet.atlassian.net/servicedesk/customer/user/login?destination=portals",
    retailerSpecific: false,
    isBookitSpecific: false,
    hasInnerRoutes: false,
  },
];